"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosTaxFeeUpdateInputSchema = exports.APosTaxFeeCreateInputSchema = exports.APosTaxFeeSchema = exports.APosTaxFeeChannelSchema = exports.APosTaxFeeRateTypeSchema = exports.APosTaxFeeTypeSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosTaxFeeTypeSchema = zod_1.z.enum(['tax', 'fee']);
exports.APosTaxFeeRateTypeSchema = zod_1.z.enum(['percentage', 'fixed']);
/** @deprecated Channel enum kept for backward compat with existing DB records */
exports.APosTaxFeeChannelSchema = zod_1.z.enum(['retail', 'b2b', 'both']);
exports.APosTaxFeeSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    taxFeeId: id_schema_1.EntityIdSchema,
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    type: exports.APosTaxFeeTypeSchema,
    rateType: exports.APosTaxFeeRateTypeSchema,
    rateValue: zod_1.z.number().nonnegative(),
    isPayableToGovernment: zod_1.z.boolean(),
    jurisdiction: zod_1.z.string().max(200).optional(),
    isCompound: zod_1.z.boolean().default(false),
    priority: zod_1.z.number().int().positive().default(1),
    displayOnReceipt: zod_1.z.boolean().default(true),
    isTaxInclusive: zod_1.z.boolean().default(false),
    isActive: zod_1.z.boolean().default(true),
    isSystem: zod_1.z.boolean().default(false),
    /** @deprecated Channel assignment now handled at category level via LocationRulesCard */
    channel: exports.APosTaxFeeChannelSchema.optional(),
    effectiveFrom: zod_1.z.string().optional(),
    effectiveTo: zod_1.z.string().optional(),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosTaxFeeCreateInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1).max(100),
    description: zod_1.z.string().max(500).optional(),
    type: exports.APosTaxFeeTypeSchema,
    rateType: exports.APosTaxFeeRateTypeSchema,
    rateValue: zod_1.z.number().nonnegative().refine((val) => val <= 100, { message: 'Rate value must be between 0 and 100 for percentage type' }),
    isPayableToGovernment: zod_1.z.boolean().optional(),
    jurisdiction: zod_1.z.string().max(200).optional(),
    isCompound: zod_1.z.boolean().optional(),
    priority: zod_1.z.number().int().positive().optional(),
    displayOnReceipt: zod_1.z.boolean().optional(),
    isTaxInclusive: zod_1.z.boolean().optional(),
    isActive: zod_1.z.boolean().optional(),
    effectiveFrom: zod_1.z.string().optional(),
    effectiveTo: zod_1.z.string().optional(),
});
exports.APosTaxFeeUpdateInputSchema = exports.APosTaxFeeCreateInputSchema.partial();
//# sourceMappingURL=taxFee.schema.js.map